import { GroupList } from '~/features/GroupList';

export const Screen: React.FC = () => {
  return <GroupList />;
};
